// extracted by mini-css-extract-plugin
export default {"form__wrap":"MeterTypeModal_form__wrap__cPi7z","form__item":"MeterTypeModal_form__item__9ntXq","form__btn__wrap":"MeterTypeModal_form__btn__wrap__8od5u"};